import {Component, Input, OnInit} from '@angular/core';
import {OrganisationAccountDTO} from "../../../../../core/dto/OrganisationAccountDTO";
import {AuthorizationService} from "../../../../../core/authorization/AuthorizationService";
import {AuthInfoDTO} from "../../../../../core/dto/AuthInfoDTO";
import {AppCodeViewComponent} from "../../../../components/code-view/code-view.component";
import {
  MatCell, MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef,
  MatTable, MatTableDataSource
} from "@angular/material/table";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {NgForOf, TitleCasePipe} from "@angular/common";
import {TablerIconsModule} from "angular-tabler-icons";
import {MatDialog} from "@angular/material/dialog";
import {RoleManagementListDialogComponent} from "./role-management-list-dialog/role-management-list-dialog.component";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {OrganisationDTO} from "../../../../DTO/Organisation/OrganisationDTO";
import {RoleService} from "../../../../services/apps/role/role.service";
import {MatTooltip} from "@angular/material/tooltip";
import {HasAuthDirective} from "../../../../../core/authorization/has-auth.directive";
import {LocalizationPipe} from "../../../../pipe/localization-pipe";

@Component({
  selector: 'app-role-management',
  imports: [
    AppCodeViewComponent,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIconButton,
    MatRow,
    MatTable,
    TablerIconsModule,
    MatTooltip,
    HasAuthDirective,
    MatHeaderRowDef,
    MatRowDef,
    MatHeaderCellDef,
    MatCellDef,
    LocalizationPipe
  ],
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition(
          'expanded <=> collapsed',
          animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class RoleManagementComponent implements OnInit {

  activeUser: AuthInfoDTO;
  dataSource: MatTableDataSource<OrganisationRole[]> = new MatTableDataSource<OrganisationRole[]>();
  displayedColumns = ['name', 'createdDate', 'updatedDate', 'detail']
  organisationRoles: OrganisationRole[];
  @Input() selectedOrganisationId: number = null;

  constructor(private authorizationService: AuthorizationService, private dialog: MatDialog, private roleService: RoleService) {}

  ngOnInit(): void {
    this.activeUser = this.authorizationService.getActiveUser()
    !this.selectedOrganisationId && (this.selectedOrganisationId = this.activeUser.organisationAccount.id);
    this.getOrganisationRolesByOrganisationId()
  }

  getOrganisationRolesByOrganisationId() {
    this.roleService.getOrganisationRoles(this.selectedOrganisationId).subscribe({
      next: (res: any) => {
        this.dataSource = res.data;
      },
      error: error => {
        this.organisationRoles = null;
      }
    })
  }

  openAuthorizationCodesDialog(roleId: number, roleName: string) {
    this.dialog.open(RoleManagementListDialogComponent, {
      width: '80vw',
      height: '80vh',
      maxWidth: 'none',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      data: {
        roleId: roleId,
        roleName: roleName,
        organisationId: this.selectedOrganisationId
      }
    })
  }
}

export interface OrganisationRole {
  id: number;
  organisation: OrganisationDTO;
  name: string;
  isActive: boolean;
  createdDate: string;
  updatedDate: string;
}
